import { render } from "./SolutionLayout.vue?vue&type=template&id=458860ee"
import script from "./SolutionLayout.vue?vue&type=script&lang=js"
export * from "./SolutionLayout.vue?vue&type=script&lang=js"
script.render = render

export default script